const routes = [
    {
        path: '/message/box',
        component: () => import('../pages/Index'),
        meta: {
            isAuthenticated: true,
            //permission: 'log_search'
        }
    },
];

export default routes;
